module.exports = __webpack_public_path__ + "static/media/tractor.ca7f052e.svg";